import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import OnboardingScreen from '../screens/onboarding/OnboardingScreen';
import AffirmationScreen from '../screens/affirmation/AffirmationScreen';
import SetIntentScreen from '../screens/set-intent/SetIntentScreen';
import BlueprintScreen from '../screens/blueprint/BlueprintScreen';
import LocalStorage from '../services/storage/LocalStorage';

/**
 * App Navigator
 * Handles routing between onboarding and main app screens
 * Shows bottom navigation only on main interface screens
 */
export const AppNavigator: React.FC = () => {
  const hasCompletedOnboarding = () => {
    const intentions = LocalStorage.getItem(LocalStorage.getKeys().INTENTIONS);
    return intentions && Array.isArray(intentions) && intentions.length > 0;
  };

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            hasCompletedOnboarding() ? (
              <Navigate to="/affirm" replace />
            ) : (
              <Navigate to="/onboarding" replace />
            )
          }
        />
        <Route path="/onboarding" element={<OnboardingScreen />} />
        <Route path="/affirm" element={<AffirmationScreen />} />
        <Route path="/journey" element={<SetIntentScreen />} />
        <Route path="/blueprint" element={<BlueprintScreen />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppNavigator;
